import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function notEmptyFieldsValidator(
  controlNames: Array<string>
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    let value = false;
    controlNames.forEach((name) => {
      const val = control.get(name)?.value;
      if (control.get(name)?.disabled || (val !== null && val !== undefined)) {
        value = true;
      }
    });
    return value ? null : { invalidNotEmptyFields: true };
  };
}
